module.exports = __webpack_public_path__ + "img/output-sun-valve.3c3d80f8.png";